module.exports = __webpack_public_path__ + "static/media/getting-fit.bece5364.jpg";